import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON_TYPE, ProductFacetNavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-facet-navigation',
  templateUrl: './custom-product-facet-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomProductFacetNavigationComponent extends ProductFacetNavigationComponent {
  iconTypes = ICON_TYPE;

}
